import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Card from 'react-bootstrap/Card';
import { FaRegEnvelope, FaSms, FaRegSun, FaBookOpen, FaRegFileWord, FaHouseDamage } from 'react-icons/fa';
import { FaCogs, FaScroll, FaUserCircle, FaCog, FaCube, FaWindowRestore,  FaPuzzlePiece } from 'react-icons/fa';
import { FaCloudUploadAlt, FaCloudDownloadAlt, Fa500Px, FaCcVisa} from 'react-icons/fa';
import { FaWhatsapp, FaMoneyBill, FaCode, FaCommentDots, FaEnvelopeSquare, FaMarsDouble } from 'react-icons/fa';
import { GrScorecard } from "react-icons/gr";
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import SettingsItem from './SettingsItem';
import { MdViewKanban } from "react-icons/md";

import './SettingsList.css';

class Settings extends React.Component {

  render() {
    const path = this.props.match.path
    let userId = reactLocalStorage.get(Const.LoggedIn);
    const models = reactLocalStorage.getObject(Const.Model);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);

    //const isGrowth = user.package === Const.PackageGrowth;
    const isEnterprise = user.package === Const.PackageEnterprise;
    const isGrowthAndAbovePackage = parseInt(user.package) >= Const.PackageGrowth;

    return (
      <section className="setting-list pt-4 pb-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Customization</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.module} link={`${path}/module`}
                      text="Customize Columns/ Fields"
                      icon={<FaCog color="#d8143f" />} name="Fields and Modules" />
                    <SettingsItem model={models.view} link={`${path}/view`}
                      text="Create, Manage Smart Views For PC/ Mobile"
                      icon={<FaWindowRestore color="#ffc107" />} name="Smart Views" />
                    {isGrowthAndAbovePackage ? (
                      <SettingsItem model={models.view} link={`${path}/kanban`}
                      text="Create, Manage Kanban Boards for Efficient Workflow"
                      icon={<MdViewKanban color="#0d6efd" />} name="Kanban Views" />
                    ) : null}
                    <SettingsItem model={models.dashboard} link={`${path}/dashboard`}
                      text="Set Up Dashboard" icon={<FaCube color="#6ac069" />} />
                    <SettingsItem model={models.dashboard} name="Widget"
                      link={`${path}/dashboard/dashlead`}
                      text="Customize Graphs"
                      icon={<FaPuzzlePiece color="#daa03d" />}
                    />
                  </ul>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Automation</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.distribution} link={`${path}/distribution`}
                      text="Distribute leads into team members"
                      icon={<FaRegFileWord color="#00400f" />} />
                    <SettingsItem model={models.automation} link={`${path}/automation`}
                      text="Automate actions insteam manual operation"
                      icon={<FaCogs color="#4f82ba" />} name="Workflow Automation" />
                    {/* { isEnterprise
                      ? <SettingsItem model={models.custom_action} link={`${path}/action`}
                        text="Custom Action Permission for all module"
                        icon={<FaList color="rgb(66 216 20)" />} name="Custom Action Permission" />
                      : null
                    }
                    { isEnterprise
                      ? <SettingsItem model={models.custom_reminder} link={`${path}/custom-reminder`}
                        text="Custom reminder for all module"
                        icon={<FaClock color="#DC3545" />} name="Custom Reminder" />
                      : null
                    } */}
                     { /** Lead Score Module */}
                    {isEnterprise ? <SettingsItem
                      model={models.lead_score}
                      link={`${path}/lead_score`}
                      text="Calculate Lead Score Automatically"
                      icon={<GrScorecard color="#4f82ba" />}
                      name="Lead Scoring"
                    />: null
                    }
                   {/* youvraj sir told me to comment this on 24/12/2024 */}
                    {/* { isEnterprise
                      ? <SettingsItem
                        model={models.auto_report}
                        link={`${path}/auto_report`}
                        text="Schedule reports on email"
                        icon={<FaSuperpowers color="#d8143f" />}
                        name="Advance Reports Automation"
                      />
                      : null
                    } */}
                  </ul>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Users and Access Control</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.role} link={`${path}/role`}
                      text="Permissions, Field Level control, Restrict actions"
                      icon={<FaScroll color="#dc3545" />} name="Roles & Permissions" />
                    <SettingsItem model={models.user} link={`${path}/user`}
                      text="List of CRM Users"
                      icon={<FaUserCircle color="rgb(0 123 255 / 25%)" />} />
                    { /*
                    <SettingsItem model={models.area} link={`${path}/area`}
                      text="Set Up Products"
                      icon={<FaListOl color="#495057" />} />
                    <SettingsItem model={models.source} link={`${path}/source`}
                      text="Set Up Source"
                      icon={<FaBraille color="#dc3545" />} />
                    */ }
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Data Management</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.import} link={`${path}/import`}
                      text="upload data into CRM" icon={<FaCloudUploadAlt color="#b2508d" />} />
                    <SettingsItem model={models.export} link={`${path}/export`}
                      text="Download data in excel" icon={<FaCloudDownloadAlt color="#62378f" />} />
                    <SettingsItem model={models.lead} link={`/lead/duplicate`}
                      text="Check Duplicate leads" icon={<FaMarsDouble color="#ff2338" />} />
                    {/*
                    <SettingsItem model={models.dashboard} link={`${path}/dashboard`}
                      text="Check Duplicate leads" icon={<FaMarsDouble color="#ff2338" />} />
                    <SettingsItem model={models.dashlead} link={`${path}/dashlead`}
                      text="Check Duplicate leads" icon={<FaMarsDouble color="#ff2338" />} />
                    <SettingsItem model={models.report} link={`/report`}
                      text="Check Duplicate leads" icon={<FaMarsDouble color="#ff2338" />} />
                    */}
                  </ul>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Templates</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.email_temp} link={`${path}/email-template`}
                      text="Add templates" icon={<FaRegEnvelope color="#ff2338" />} />
                    <SettingsItem model={models.sms_temp} link={`${path}/sms-template`}
                      text="Add templates" icon={<FaSms color="rgb(64, 154, 215)" />} />
                    <SettingsItem model={models.whatsapp_temp} link={`${path}/whatsapp-template`}
                      text="Add templates" icon={<FaWhatsapp color="rgb(66 216 20)" />} />
                    <SettingsItem model={models.property_project_temp} link={`${path}/property-project`}
                      text="Add templates" icon={<FaHouseDamage color="#BC4A3C" />} />
                  </ul>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Third Party Integration</h4>
                  <ul className="settinglist">
                    <SettingsItem name = {"Market Place"} model={models.api} link={`${path}/third-party`}
                      text="App Integration" icon={<FaCode color="#c01498" />} />
                    <SettingsItem model={models.email_config} link={`${path}/email-configuration`}
                      text="Add Configurations" icon={<FaRegSun color="rgb(20 154 216)" />} />
                    <SettingsItem model={models.sms_config} link={`${path}/sms-configuration`}
                      text="Add Configurations" icon={<FaRegSun color="#d8143f" />} />
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="row pt-5">

            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>General</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.user} link={`${path}/user/preview/${userId}`}
                      text="View Personal Settings"
                      icon={<FaRegSun color="#d8143f" />} name="Personal Settings" />
                    <SettingsItem model={models.company} link={`${path}/company-preview`}
                      text="View Company Details"
                      icon={<FaBookOpen color="#daa03d" />} name="Company Details" />
                    <li>
                      <NavLink to={`${path}/billing`}><FaCcVisa color="#006b38" /> Billing </NavLink>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Model List</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.note} link={`/note`}
                      text="Note List" icon={<FaEnvelopeSquare color="#2d3fa1" />} />
                    <SettingsItem model={models.probability} link={`${path}/probability`}
                      text="Set Up Probability" icon={<Fa500Px color="#143d59" />} />
                    <SettingsItem model={models.installment_mode} link={`${path}/installment_mode`}
                      text="Set Up Installment Mode" icon={<FaMoneyBill color="#143d59" />} />
                  </ul>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4">
              <Card>
                <Card.Body>
                  <h4>Marketing</h4>
                  <ul className="settinglist">
                    <SettingsItem model={models.mass_mail} link={`${path}/mass-mail`}
                      text="Email Marketing Integration" icon={<FaEnvelopeSquare color="#2d3fa1" />} />
                    <li>
                      <NavLink to={`${path}/mass-sms`}>
                        <FaCommentDots color="#409ad7" /> Mass Sms
                      </NavLink>
                      <p>SMS Marketing Integration</p>
                    </li>
                    <li>
                      <NavLink to={`${path}/mass-whatsapp`}>
                        <FaWhatsapp color="rgb(66 216 20)" />Mass WhatsApp
                      </NavLink>
                      <p>WhatsApp Marketing Integration</p>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default withRouter(Settings);